import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { SupplierCard } from 'entities/Supplier/ui/SupplierCard/SupplierCard';

import { useSuppliers } from '../lib';

export const SupplierDetails = () => {
    const { t } = useTranslation();
    const suppliers = useSuppliers();

    const renderContent = () => {
        if (suppliers.length === 0) {
            return (
                <Typography
                    typography="openSans.body2"
                    fontSize="14px"
                    color="grey.600"
                >
                    {t('No supplier information available')}
                </Typography>
            );
        }

        return (
            <Box>
                {suppliers.map((supplier) => (
                    <SupplierCard
                        data-testclass="supplier-card"
                        key={supplier.sellerUid}
                        supplierInfo={supplier}
                    />
                ))}
            </Box>
        );
    };

    return (
        <Box sx={{ flex: 1 }}>
            <Typography typography="openSans.subtitle1Medium" mb="20px">
                {t('Supplier details')}
            </Typography>

            {renderContent()}
        </Box>
    );
};
